import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { StyledFieldSet } from 'components/StyledElements'
import { exportFile } from 'utils/ExportDataUtil'
import { Button, Stack, Typography } from '@mui/material'
import FileDownloadIcon from '@mui/icons-material/FileDownload'

const headers = ['code', 'name', 'basinCode', 'basinLabel', 'siret', 'indusSiteName', 'citySite']

const ImportOptionsStep = ({
    setFileContent = () => { },
    setFileName = () => { },
}) => {
    const onUploadFile = (e) => {
        const reader = new FileReader()
        const file = e.target.files[0]
        if (file) {
            setFileName(file.name)
            reader.onloadend = (event) => {
                const split = event.target.result.split(',')
                setFileContent(split[1])
            }
            reader.readAsDataURL(file)
        }
    }

    return (
        <StyledFieldSet>
            <Typography fontStyle='italic'>{i18n.typeXSLXFiletoSTEP}</Typography>
            <Stack marginLeft={3}>
                <Typography>{i18n.stepCodeRequired}</Typography>
                <Typography>{i18n.stepName}</Typography>
                <Typography>{i18n.basinCodeRequired}</Typography>
                <Typography>{i18n.basinLabel}</Typography>
                <Typography>{i18n.siretNumberRequired}</Typography>
                <Typography>{i18n.indusSiteName}</Typography>
                <Typography>{i18n.municipalityEstablishment}</Typography>
            </Stack>
            <Button
                variant='contained'
                onClick={() => exportFile({ data: [{ headers }], exportType: 'xlsx', titleFile: i18n.model }, true)}
                endIcon={(<FileDownloadIcon/>)}
                sx={{ marginTop: 2 }}
            >
                {i18n.downloadExcelTemplate}
            </Button>
            <div className='file-field input-field'>
                <div className='btn'>
                    <span>{i18n.importLabel}</span>
                    <input
                        accept='.xls, .xlsx'
                        type='file'
                        onChange={onUploadFile}
                    />
                </div>
                <div className='file-path-wrapper'>
                    <input className='file-path validate' type='text' />
                </div>
            </div>
        </StyledFieldSet>
    )
}

ImportOptionsStep.propTypes = {
    setFileContent: PropTypes.func,
    setFileName: PropTypes.func,
}

export default ImportOptionsStep